/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AnnouncementNotificationActionData } from './AnnouncementNotificationActionData';
import {
    AnnouncementNotificationActionDataFromJSON,
    AnnouncementNotificationActionDataFromJSONTyped,
    AnnouncementNotificationActionDataToJSON,
} from './AnnouncementNotificationActionData';

/**
 * 
 * @export
 * @interface AnnouncementNotificationAction
 */
export interface AnnouncementNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof AnnouncementNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof AnnouncementNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {AnnouncementNotificationActionData}
     * @memberof AnnouncementNotificationAction
     */
    data: AnnouncementNotificationActionData;
}

/**
 * Check if a given object implements the AnnouncementNotificationAction interface.
 */
export function instanceOfAnnouncementNotificationAction(value: object): value is AnnouncementNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function AnnouncementNotificationActionFromJSON(json: any): AnnouncementNotificationAction {
    return AnnouncementNotificationActionFromJSONTyped(json, false);
}

export function AnnouncementNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnnouncementNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': AnnouncementNotificationActionDataFromJSON(json['data']),
    };
}

export function AnnouncementNotificationActionToJSON(value?: AnnouncementNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': AnnouncementNotificationActionDataToJSON(value.data),
    };
}

